import { render } from "./VideoPlay.vue?vue&type=template&id=753e40e4"
import script from "./VideoPlay.vue?vue&type=script&lang=js"
export * from "./VideoPlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__